import { getActiveInterfaceLocale } from '@/shared/i18n/locale';
import { translate } from '@/shared/i18n/translations';
import { AlertType } from '@/shared/types/Alert';

import { getErrorMessage } from './getErrorMessage';
import { enqueueAppSnackbar } from './snackbar';

export const showErrorAlert = (error: unknown) => {
  const fallbackMessage = translate(getActiveInterfaceLocale(), 'common.serverError');
  enqueueAppSnackbar(getErrorMessage(error, fallbackMessage), { variant: AlertType.Error });
};
